import { useCandidateConsentTimeline } from '@/hooks/use-candidates';
import type { CandidateDetail } from '@/types/candidates';
import { CandidateGdprQuickActions } from './candidate-gdpr-quick-actions';
import { CandidateGdprRetentionCard } from './candidate-gdpr-retention-card';
import { CandidateGdprStatusCard } from './candidate-gdpr-status-card';
import { CandidateGdprTimeline } from './candidate-gdpr-timeline';

interface CandidateGdprTabProps {
  candidate: CandidateDetail;
}

export function CandidateGdprTab({ candidate }: CandidateGdprTabProps) {
  const { data, isLoading, error } = useCandidateConsentTimeline(candidate.id);

  if (isLoading) {
    return (
      <div className="rounded-md border border-border bg-background p-4 text-sm text-muted-foreground">
        Loading GDPR timeline…
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="rounded-md border border-destructive/40 bg-destructive/10 p-4 text-sm text-destructive">
        Failed to load consent timeline.
      </div>
    );
  }

  return (
    <section className="space-y-6">
      <div>
        <h2 className="text-base font-medium">GDPR</h2>
        <p className="text-sm text-muted-foreground">
          Consent status, timeline, and GDPR Art. 17 erasure.
        </p>
      </div>

      <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_320px]">
        <div className="space-y-6">
          <CandidateGdprStatusCard candidate={candidate} timeline={data} />
          <CandidateGdprTimeline events={data.events} />
        </div>
        <aside className="space-y-6">
          <CandidateGdprQuickActions />
          <CandidateGdprRetentionCard timeline={data} />
        </aside>
      </div>
    </section>
  );
}
